const slotsSwipers = document.querySelectorAll('.r-slots-list-swiper')
if(slotsSwipers) {
  slotsSwipers.forEach((swiper) => {
    new Swiper(swiper, {
      slidesPerView: 6,
      spaceBetween: 16,
      breakpoints:{
        320: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3
        },
        1024: {
          slidesPerView: 4,
        },
        1240: {
          slidesPerView: 5,
        },
        1366: {
          slidesPerView: 8
        }
      }
    })
  })
}